"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackExposureResponse = void 0;
var tslib_1 = require("tslib");
var bi_logger_1 = require("./bi-logger");
exports.trackExposureResponse = function (params) {
    // tslint:disable-next-line no-floating-promises
    bi_logger_1.biLogger.log(tslib_1.__assign(tslib_1.__assign({}, params), { evid: 815 }));
};
//# sourceMappingURL=track-exposure-response.js.map